import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import LayoutBody from "../components/LayoutBody";
import Typography from "../components/Typography";
import ImageVideo from "./ImageVideo";
import { HorizontalAd } from "home/Ad";

import Button from "../components/Button";

const styles = (theme) => ({
    root: {
        marginTop: theme.spacing(8),
        marginBottom: theme.spacing(4)
    },
    images: {
        marginTop: theme.spacing(4),
        display: "flex",
        flexWrap: "wrap"
    }
});

function ProductCategories(props) {
    const { classes } = props;

    const images = [
        {
            url: "img/templates/JSNation_2.png",
            src: "vid/templates/JSNationY.mp4",
            title: "Circle Spectrum",
            width: "40%",
            templateName: "editor?project=fe7acdd6-bbcc-467f-a4a1-52b19b970384",
            attrib: "@caseif & @Incept",
            attribUrl: "https://github.com/caseif/js.nation",
            license: "Free"
        },
        {
            url: "img/templates/Polartone_2.png",
            src: "vid/templates/PolartoneY.mp4",
            title: "Polartone",
            width: "24%",
            templateName: "editor?template=Polartone",
            attrib: "@mattdesl",
            attribUrl: "https://github.com/mattdesl/Polartone",
            license: "Free"
        },
        {
            url: "img/templates/Monstercat_2.png",
            src: "vid/templates/MonstercatY.mp4",
            title: "Monstercat Bar Visualizer",
            width: "36%",
            templateName: "editor?project=c1ec78f7-3c67-4d10-80bc-70cdb8b8cf0d",
            attrib: "@caseif & @Incept",
            attribUrl: "https://github.com/caseif/vis.js",
            license: "Free"
        },
        {
            url: "img/templates/StarField_2.png",
            src: "vid/templates/StarNestY.mp4",
            title: "Star Field",
            width: "32%",
            templateName: "editor?template=Stars",
            attrib: "@kali",
            attribUrl: "https://www.shadertoy.com/user/kali",
            license: "Free"
        },
        {
            url: "img/templates/linebed_2.png",
            src: "vid/templates/linebedY.mp4",
            title: "Linebed",
            width: "38%",
            templateName: "editor?project=a9a2e6e3-8c8b-44ca-8d44-f4400e6d835e",
            attrib: "GamleGaz",
            attribUrl: "https://musicvid.org",
            twitter: "",
            license: "Free"
        },
        {
            url: "img/templates/UniverseWithin_2.png",
            src: "vid/templates/UniverseWithinY.mp4",
            title: "Universe Within",
            width: "30%",
            templateName: "editor?template=UniverseWithin",
            attrib: "@BigWIngs",
            attribUrl:
                "https://www.youtube.com/channel/UCcAlTqd9zID6aNX3TzwxJXg",
            twitter: "https://twitter.com/The_ArtOfCode",
            license: "Attribution Required"
        },

        {
            url: "img/templates/AudioWave_2.png",
            src: "vid/templates/TimerepY.mp4",
            title: "Audio Wave",
            width: "30%",
            templateName: "editor?template=AudioWave",
            attrib: "@GamleGaz",
            attribUrl: "https://www.github.com/AlexVestin",
            license: "Free"
        },
        {
            url: "img/templates/HexaGone_2.png",
            src: "vid/templates/HexagoneY.mp4",
            title: "HexaGone",
            width: "40%",
            templateName: "editor?project=96f76587-2e0a-4e00-9ad5-fddc96d9925e",
            attribUrl:
                "https://www.youtube.com/channel/UCcAlTqd9zID6aNX3TzwxJXg",
            twitter: "https://twitter.com/The_ArtOfCode",
            attrib: "@BigWIngs",
            license: "Attribution Required"
        },
        {
            url: "",
            src: "",
            title: "More templates",
            width: "30%",
            templateName: "templates",
            attribUrl: "",
            twitter: "",
            attrib: "",
            license: ""
        }
    ];

    /*
     {
      url:'img/templates/Noise.png',
      src: "vid/templates/NoiseY.mp4",
      title: 'Electric Noise',
      width: '40%',
      templateName: "editor?template=Noise",
      attrib: "nmz (@stormoid)",
      attribUrl: "https://www.shadertoy.com/user/nimitz",
      twitter: "https://twitter.com/stormoid",
      license: "Attribution Required"
    },


  */

    /*url: 'img/templates/SimplicityGalaxy.png',
      title: 'Simplicity Galaxy',
      width: '20%',
      templateName: "SimplicityGalaxy",
      attrib: "@CBS",
      attribUrl: "https://www.shadertoy.com/user/CBS",
      license: "FREE" */
    return (
        <LayoutBody
            className={classes.root}
            component="section"
            width="large"
            id="FeaturedProjectsTitle"
        >
            <HorizontalAd slot="7955649201" />

            <Typography
                variant="h4"
                marked="center"
                align="center"
                component="h2"
            >
                Featured projects
            </Typography>

            <Typography align="center">
                <a style={{ color: "inherit" }} href="/templates">
                    (More projects here)
                </a>
            </Typography>

            <div className={classes.images} id="FeaturedProjects">
                {images.map((image) => (
                    <ImageVideo image={image} key={image.title}></ImageVideo>
                ))}
            </div>

            <div
                style={{
                    width: "95%",
                    textAlign: "center",
                    margin: 20,
                    borderBottom: "1px solid rgba(0,0,0,0.15)"
                }}
            ></div>

            <HorizontalAd slot="7955649201" />
            <Typography
                variant="h4"
                marked="center"
                align="center"
                component="h2"
            >
                Want more?
            </Typography>

            <div
                style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                <Button
                    color="primary"
                    variant="contained"
                    size="large"
                    //href="#FeaturedProjects"
                    className={classes.button}
                    style={{ textAlign: "center", color: "white", margin: 50 }}
                    href="/templates"
                    //onClick={() => this.setState({ redirectTo: "/editor" })}
                >
                    {" "}
                    Check out more templates{" "}
                </Button>
            </div>
        </LayoutBody>
    );
}

ProductCategories.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ProductCategories);
